module.exports = __webpack_public_path__ + "static/media/car.48d20e70.svg";